var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeGbp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "#FFDE8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.444 4.293c.453 0 .837.083 1.153.249.315.166.556.397.722.693.166.293.25.635.25 1.026H9.386c0-.244-.046-.438-.137-.581a.791.791 0 00-.361-.318 1.165 1.165 0 00-.479-.097.897.897 0 00-.478.131.898.898 0 00-.332.391 1.495 1.495 0 00-.122.64l.043 1.191H9.06v.952H7.557l.033.884c.003.313-.054.592-.171.84-.04.084-.088.162-.146.234h3.373l.005.972H5.54v-.972h.425a.363.363 0 00.244-.205c.059-.114.098-.245.117-.395.023-.153.034-.296.034-.43l-.03-.928h-.81v-.952h.778l-.04-1.191c0-.45.093-.832.278-1.148.189-.319.448-.563.777-.732a2.44 2.44 0 011.132-.254z",
    fill: "#000"
  })));
}
SvgPokerGameTypeGbp.displayName = 'PokerGameTypeGbp';
export default SvgPokerGameTypeGbp;